<div class="error-container">
    <div class="error-block" *ngIf="errcode.code === 9500">
        <sync-icon class="preview-file-icon" name="file-document"></sync-icon>
        <div class="preview-wrap-icon-inner-file-name">
            <span class="h5">File not available</span>
            <sync-button type="filled" label="Go back to Home" [onClick]="goHome">
            </sync-button>
        </div>
    </div>
    <div class="error-block error-no-header-block" *ngIf="errcode.code === 9401">
        <img src="assets/images/group-logo.png" alt="Audio File">
        <div class="preview-wrap-icon-inner-file-name">
            <span class="h5">You are not signed in to Sync</span>
            <div class="error-btn-group">    
            <sync-button type="outlined" label="Create account" [onClick]="goSync">
            </sync-button>
            <sync-button type="filled" label="Sign in" [onClick]="goLoginPage">
            </sync-button>
        </div>
        </div>
    </div>
</div>